/** Prefer handle for public UI; never surface OAuth/login emails as visible names or @handles. */
export function looksLikeEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s.trim())
}

/** Returns username when safe for display (not empty, not email-shaped); otherwise null. */
export function publicHandleOrNull(username: string | null | undefined): string | null {
  const u = username?.trim() ?? ''
  if (!u || looksLikeEmail(u)) return null
  return u
}

/** `@handle` for UI, or null when the handle would expose an email address. */
export function publicAtHandle(username: string | null | undefined): string | null {
  const h = publicHandleOrNull(username)
  return h ? `@${h}` : null
}

/**
 * Visible member handle when only `username` is available (no display_name).
 * Never returns an email-shaped string.
 */
export function visibleUsernameOnly(username: string | null | undefined): string {
  return publicHandleOrNull(username) ?? 'Member'
}

/** Public attribution label — username only (never display name or email). */
export function guideAuthorDisplayLabel(author: {
  username?: string | null
  /** Ignored in UI — public labels use username only. */
  display_name?: string | null
}): string {
  return visibleUsernameOnly(author.username)
}

export function guideAuthorInitial(author: {
  username?: string | null
  display_name?: string | null
}): string {
  const u = publicHandleOrNull(author.username)
  const ch = u?.charAt(0)
  return ch ? ch.toUpperCase() : '?'
}

/** Reply / mention line: `@username` when safe, else neutral label (never an email). */
export function mentionLabel(username: string | null | undefined): string {
  const at = publicAtHandle(username)
  if (at) return at
  return visibleUsernameOnly(username)
}
